import React from 'react';
import { object } from 'prop-types';

import s from './Attachments.css';


const Attachments = ({ ...props }) => {

  const allAttachments = props.attachments;

  // Verify attachments exist, otherwise return nothing
  if (!allAttachments) {
    return null;
  }

  const downloadAttachments = allAttachments.downloads;
  const imageAttachments = allAttachments.images;

  // Determine if each type has any attachments
  const hasAttachmentDownloads = (downloadAttachments && downloadAttachments.length >= 1);
  const hasAttachmentImages = (imageAttachments && imageAttachments.length >= 1);

  // Only if attachments exist should anything be rendered
  if (!hasAttachmentDownloads && !hasAttachmentImages) {
    return null;
  }

  // Build attachment download links
  const renderAttachmentDownload = downloadAttachments.map((a) => {
    const attachmentId = a.id;
    const caption = a.caption;
    const timestamp = a.time;

    return (
      <li
        key={attachmentId}
        id={attachmentId}
        className={s.attachment}
      >
        <a
          download
          href={`/api/download/${timestamp}/${attachmentId}`}
          title={`Download ${caption}`}
          className={s.link}
        >
          {caption}
        </a>
      </li>
    );
  });

  // Build attachment image sources
  const renderAttachmentImage = imageAttachments.map((a) => {
    const attachmentId = a.id;
    const caption = a.caption;
    const timestamp = a.time;

    return (
      <li
        key={attachmentId}
        id={attachmentId}
        className={s.attachment}
      >
        <img
          src={`/api/images/${timestamp}/${attachmentId}`}
          title={caption}
          alt={caption}
          className={s.image}
        />
      </li>
    );
  });

  // Render attachments
  return (
    <section className={s.component}>
      <header className={s.header}>
        Attachments:
      </header>
      <ul className={s.list}>
        {renderAttachmentDownload}
        {renderAttachmentImage}
      </ul>
    </section>
  );
};

/**
 * @props
 * attachments
 */
Attachments.propTypes = {
  attachments: object,
};

export default Attachments;



// WEBPACK FOOTER //
// ./src/components/Pages/Messages/Attachments/Attachments.js